import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import CS from "../commons/services/Common";
import VS from "../commons/services/Validation";
import { ROUTES } from "../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";
// import AS from "../pages/Login/Service/Authentication";

// import { Message, MessageBox } from "element-react";

/**
 * 아이디/비밀번호 찾기 컴포넌트
 */
class FindAccount extends Component {
  constructor(props) {
    super(props);
    this.authNumber = "";
    this.isTrueAuthNumber = false;

    // this.checkAuthNumber = this.checkAuthNumber.bind(this);
  }

  sendEmail = async () => {
    let email = CS.$("#mail1") + "@" + CS.$("#mail2");
    const { t } = this.props;
    if (!VS.isValidEmail(email)) {
      document.getElementById("mail2").focus();
      return;
    } else {
      axios
        .get(`/api/send-temp-password/${email}`)
        .then((res) => {
          CS.notification("success", t("key709"));
        })
        .catch((error) => {
          CS.notification("error", error.response.data.message);
        });
    }
  };

  render() {
    document.body.className = "";
    const { t } = this.props;
    return (
      <>
        <div className="page-tit">
          <div className="container">
            <h2 className="tit">{t("key703")}</h2>
          </div>
        </div>
        <div className="container">
          <div className="card2 mt-40 find-form">
            <h3 className="title">{t("key704")}</h3>
            <p>{t("key705")}</p>
            <p>{t("key706")}</p>
            <div className="form-inline3 mt-40">
              <div className="form-group inline">
                <label htmlFor="mail1" className="tit w100">
                  {t("key707")}
                </label>
                <input type="text" id="mail1" name="mail1" className="w250" />
                <span className="mail-unit">@</span>
                <input type="text" id="mail2" name="mail2" className="w250" />
              </div>
            </div>
            <div className="btn-areaC2">
              <button
                type="button"
                className="btn primary"
                onClick={this.sendEmail}
              >
                {t("key708")}
              </button>
            </div>
          </div>

          <div className="card2 mt-30 find-text">
            <p className="tit">
              {t("key710")}
              {/* 회원가입시 사용했던 이메일 주소로 메일이 도착하지 않으신다면
              고객센터로 문의주시기 바랍니다. */}
            </p>
            <p className="size15 mt-20">{t("key711")}</p>
            <hr className="dashed" />
            <div className="foot">
              <span className="mr-20">{t("key712")}</span>
              <Link to={ROUTES.SIGNUP}>{t("key713")}</Link>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(FindAccount);
